import * as React from 'react';
import cx from 'classnames';

import { Clickable } from '../Clickable/Clickable';
import { Divider } from '../Divider/Divider';
import { routes } from '../../config/routes';

import backendDevelopmentIcons from './assets/backend-development.image.svg';
import blockchainDevelopmentIcons from './assets/blockchain-development.image.svg';
import frontendDevelopmentIcons from './assets/frontend-development.image.svg';
import mobileDevelopmentIcons from './assets/mobile-development.image.svg';
import auditAndOptimizationIcons from './assets/audit-and-optimization.image.svg';
// import productDevelopmentIcons from './assets/software-development.image.svg';
// import uiAuditIcons from './assets/ui-audit.image.svg';
// import productLaunchIcons from './assets/product-launch.image.svg';
import designSprintIcons from './assets/design-sprint.image.svg';
import SREDevelopmentIcons from './assets/sre.image.svg';

import * as cs from './ServiceCard.module.css';

const MAP_SERVICE_TO_ICONS = {
  'backend-development': {
    component: backendDevelopmentIcons,
    /* position: {
      right: '100%',
      top: '50%',
      transform: 'translateY(-50%)',
    }, */
  },
  'audit-and-optimization': {
    component: auditAndOptimizationIcons,
  },
  'blockchain-development': {
    component: blockchainDevelopmentIcons,
    position: {
      right: '8px',
      bottom: '-8px',
    },
  },
  'frontend-development': {
    component: frontendDevelopmentIcons,
    position: {
      right: '-18px',
      bottom: '8px',
    },
  },
  'mobile-development': {
    component: mobileDevelopmentIcons,
    position: {
      left: '100%',
      top: '42px',
    },
  },
  // 'software-development': {
  //   component: productDevelopmentIcons,
  // },
  sre: {
    component: SREDevelopmentIcons,
    position: {
      right: '8px',
      bottom: '-8px',
      // transform: 'translateX(50%)',
    },
  },
  'product-launch': {
    // component: productLaunchIcons,
  },
  'design-sprint': {
    component: designSprintIcons,
  },
  'ui-audit': {
    // component: uiAuditIcons,
  },
};

interface Props {
  title: string;
  description: string;
  slug: string;
  size: 'md' | 'lg';
  withIcons: boolean;
  index: number;
  trackEvent?: string;
}

export const ServiceCard = ({
  title,
  description,
  slug,
  size,
  withIcons,
  index,
  trackEvent,
}: Props) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const { component: Icons, position } = MAP_SERVICE_TO_ICONS[slug] || {};

  const url = routes.service(slug);

  return (
    <article
      className={cx(cs.root, cs[`size_${size}`], {
        [cs.firstTile]: index === 0,
      })}
    >
      <Clickable
        className={cs.link}
        to={url}
        trackEvent={trackEvent}
        trackLabel={trackEvent ? url : undefined}
      >
        <h2 className={cs.title}>{title}</h2>

        <Divider isDecorative className={cs.divider} />

        <p className={cs.description}>{description}</p>
        {withIcons && Icons && (
          <div className={cs.iconsWrapper}>
            <img
              src={Icons}
              alt={`${title} icon`}
              className={cs.icons}
              style={position}
              aria-hidden
              loading="lazy"
            />
          </div>
        )}
      </Clickable>
    </article>
  );
};
